import styled from 'styled-components'

export const ModalContentWrapper = styled.div`
  table .suicr-day-view-header span,
  table .suicr-hour-view-header span,
  table .suicr-minute-view-header span {
    text-transform: capitalize;
  }
`
